import React from 'react';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { Plus, Trash2 } from 'lucide-react';

const DeductionsSection = ({ 
  deductions, 
  addDeduction, 
  updateDeduction, 
  removeDeduction,
  calculateTotalDeductions 
}) => {
  return (
    <div className="space-y-4 p-4 bg-red-500/5 rounded-lg border border-red-500/20">
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-medium text-red-400">Deductions</h3>
        <Button
          type="button"
          variant="outline"
          size="sm"
          onClick={addDeduction}
          className="border-red-500/50 text-red-400 hover:bg-red-500/10"
        >
          <Plus className="h-3 w-3 mr-1" />
          Add Deduction
        </Button>
      </div>
      {deductions.map((deduction, idx) => (
        <div key={deduction._key || idx} className="space-y-2 p-2 bg-slate-900/50 rounded">
          <div className="flex items-center gap-2">
            <Input
              value={deduction.name}
              onChange={(e) => updateDeduction(idx, 'name', e.target.value)}
              placeholder="e.g., Company Margin"
              className="bg-slate-800 border-slate-600 text-white flex-1"
            />
            <Input
              type="number"
              value={deduction.amount}
              onChange={(e) => updateDeduction(idx, 'amount', e.target.value)}
              placeholder="£"
              className="bg-slate-800 border-slate-600 text-white w-24"
              min="0"
              step="0.01"
            />
            <Button
              type="button"
              variant="ghost"
              size="sm"
              onClick={() => removeDeduction(idx)}
              className="text-red-400 hover:text-red-300 hover:bg-red-500/10"
            >
              <Trash2 className="h-4 w-4" />
            </Button>
          </div>
          <Input
            type="month"
            value={deduction.applies_to_month}
            onChange={(e) => updateDeduction(idx, 'applies_to_month', e.target.value)}
            placeholder="Applies to month"
            className="bg-slate-800 border-slate-600 text-white"
          />
        </div>
      ))}
      {deductions.length > 0 && (
        <div className="text-sm text-red-400">
          Total Deductions: £{calculateTotalDeductions()}
        </div>
      )}
    </div>
  );
};

export default DeductionsSection;
